export enum EnvironmentsEnum {
    local = "Local",
    development = "Development",
    acceptance = "Acceptance",
    production = "Production"
}